/* SonaSleep theme JS  -  cart AJAX, cart drawer, reveal animations, countdown timers. */
(function () {
  'use strict';

  /* ---------- Scroll reveal (replaces framer-motion whileInView) ---------- */
  function initScrollReveal() {
    var els = document.querySelectorAll('.scroll-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '-50px' });
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Countdown-to-midnight (announcement bar + bundle upsell timers) ---------- */
  function tickCountdownToMidnight() {
    var els = document.querySelectorAll('[data-countdown-to-midnight]');
    if (!els.length) return;
    var now = new Date();
    var end = new Date();
    end.setHours(23, 59, 59, 999);
    var diff = Math.max(0, end - now);
    var h = String(Math.floor(diff / 3600000)).padStart(2, '0');
    var m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
    var s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
    els.forEach(function (el) { el.textContent = h + ':' + m + ':' + s; });
  }

  /* ---------- 10-minute bundle-offer countdown (resets each time cart opens) ---------- */
  var upsellInterval = null;
  function startUpsellCountdown() {
    var els = document.querySelectorAll('[data-upsell-countdown]');
    if (!els.length) return;
    var seconds = 10 * 60;
    clearInterval(upsellInterval);
    function render() {
      var m = String(Math.floor(seconds / 60)).padStart(2, '0');
      var s = String(seconds % 60).padStart(2, '0');
      els.forEach(function (el) { el.textContent = m + ':' + s; });
    }
    render();
    upsellInterval = setInterval(function () {
      seconds = Math.max(0, seconds - 1);
      render();
      if (seconds === 0) clearInterval(upsellInterval);
    }, 1000);
  }

  /* ---------- 10-minute cart reservation timer ---------- */
  var reservationInterval = null;
  function startReservationTimer() {
    var el = document.querySelector('[data-reservation-timer]');
    if (!el) return;
    var seconds = 10 * 60;
    clearInterval(reservationInterval);
    function render() {
      var expired = seconds <= 0;
      var m = String(Math.floor(seconds / 60)).padStart(2, '0');
      var s = String(seconds % 60).padStart(2, '0');
      el.classList.toggle('bg-destructive/8', expired);
      el.classList.toggle('border-destructive/20', expired);
      el.classList.toggle('bg-primary/8', !expired);
      el.classList.toggle('border-primary/20', !expired);
      el.innerHTML = expired
        ? '<span class="font-semibold text-destructive/90">Reservation expired  -  checkout now.</span>'
        : 'Reserved for <span class="font-semibold tabular-nums text-primary">' + m + ':' + s + '</span>  -  secure today\'s offer.';
    }
    render();
    reservationInterval = setInterval(function () {
      seconds = Math.max(0, seconds - 1);
      render();
      if (seconds === 0) clearInterval(reservationInterval);
    }, 1000);
  }

  /* ============================================================
     Cart AJAX  -  thin wrapper over Shopify's native cart endpoints.
     Bundle pricing is handled entirely by Shopify's own automatic
     discounts (configured in Shopify Admin > Discounts), so this
     layer only ever adds real variants at real prices/quantities.
     ============================================================ */
  var Cart = {
    get: function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    },
    add: function (items) {
      // items: [{ id: <variant id>, quantity: <n>, properties: {...} }]
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
        return r.json();
      });
    },
    changeLine: function (line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      }).then(function (r) { return r.json(); });
    },
    changeById: function (id, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity }),
      }).then(function (r) { return r.json(); });
    },
    updateDiscount: function (code) {
      // Shopify applies a manual discount code via the cart's discount attribute at checkout,
      // not the cart endpoint itself  -  we forward it as a URL param on the checkout redirect.
      return Promise.resolve(code);
    },
  };
  window.SonaSleepCart = Cart;

  function renderCartCount(cart) {
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return;
    badge.textContent = cart.item_count;
    badge.classList.toggle('hidden', cart.item_count === 0);
    badge.classList.toggle('flex', cart.item_count > 0);
  }

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-drawer-overlay');
    if (!drawer || !overlay) return;
    overlay.classList.remove('hidden');
    drawer.classList.remove('translate-x-full');
    document.body.style.overflow = 'hidden';
    startReservationTimer();
    startUpsellCountdown();
    refreshCartDrawer();
  }

  function closeCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-drawer-overlay');
    if (!drawer || !overlay) return;
    overlay.classList.add('hidden');
    drawer.classList.add('translate-x-full');
    document.body.style.overflow = '';
    clearInterval(reservationInterval);
    clearInterval(upsellInterval);
  }
  window.SonaSleepCloseCartDrawer = closeCartDrawer;

  function refreshCartDrawer() {
    Cart.get().then(function (cart) {
      var event = new CustomEvent('cart:updated', { detail: cart });
      document.dispatchEvent(event);
    });
  }

  function addToCartAndOpen(items, button) {
    if (button) { button.disabled = true; }
    Cart.add(items)
      .then(function () {
        refreshCartDrawer();
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('[cart] add failed:', err.message);
        alert(err.message || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        if (button) { button.disabled = false; }
      });
  }
  window.SonaSleepAddToCart = addToCartAndOpen;

  function goToCheckout() {
    var code = window.SonaSleepCheckoutDiscount;
    window.location.href = code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
  }
  window.SonaSleepCheckout = goToCheckout;

  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    tickCountdownToMidnight();
    setInterval(tickCountdownToMidnight, 1000);

    if (window.lucide) window.lucide.createIcons();

    var cartToggle = document.querySelector('[data-cart-toggle]');
    if (cartToggle) cartToggle.addEventListener('click', openCartDrawer);

    var closeButtons = document.querySelectorAll('[data-cart-close]');
    closeButtons.forEach(function (btn) { btn.addEventListener('click', closeCartDrawer); });

    var overlay = document.getElementById('cart-drawer-overlay');
    if (overlay) overlay.addEventListener('click', closeCartDrawer);

    document.addEventListener('cart:updated', function (e) { renderCartCount(e.detail); });

    refreshCartDrawer();
  });
})();
